export const vehicles = [
  {
    vehicleType: 1,
    fullLoad: 19,
    vehicleMass: 13,
    vehicleTitle:
      'Gross vehicle mass 32 t, pay load capacity 19 t (Earth moving lorry)',
    environmentalClass: [
      {
        class: '--> 1993',
        carbon: { empty: 585.9, full: 820.5 },
        fuelConsumption: { empty: 24.9, full: 34.9 },
      },
      {
        class: 'EURO I (1994 - 1995)',
        carbon: { empty: 571.3, full: 782.7 },
        fuelConsumption: { empty: 24.3, full: 33.3 },
      },
      {
        class: 'EURO II (1996 - 2000)',
        carbon: { empty: 558.2, full: 767.2 },
        fuelConsumption: { empty: 23.7, full: 32.7 },
      },
      {
        class: 'EURO III (2001 - 2005)',
        carbon: { empty: 568.1, full: 780.0 },
        fuelConsumption: { empty: 24.2, full: 33.2 },
      },
      {
        class: 'EURO IV (2006 - 2008)',
        carbon: { empty: 546.5, full: 747.5 },
        fuelConsumption: { empty: 23.1, full: 31.7 },
      },
      {
        class: 'EURO V (2009 - 2014)',
        carbon: { empty: 558.5, full: 755.5 },
        fuelConsumption: { empty: 23.2, full: 31.6 },
      },
      {
        class: 'EURO VI 2015 -->',
        carbon: { empty: 555.3, full: 749.8 },
        fuelConsumption: { empty: 23.1, full: 31.4 },
      },
    ],
  },
  {
    vehicleType: 2,
    fullLoad: 25,
    vehicleMass: 15,
    vehicleTitle:
      'Gross vehicle mass 40 t, pay load capacity 25 t (Semi trailer combination)',
    environmentalClass: [
      {
        class: '--> 1993',
        carbon: { empty: 656.8, full: 946.5 },
        fuelConsumption: { empty: 27.9, full: 40.3 },
      },
      {
        class: 'EURO I (1994 - 1995)',
        carbon: { empty: 636.8, full: 926.4 },
        fuelConsumption: { empty: 27.1, full: 39.4 },
      },
      {
        class: 'EURO II (1996 - 2000)',
        carbon: { empty: 627.9, full: 974.3 },
        fuelConsumption: { empty: 26.7, full: 41.5 },
      },
      {
        class: 'EURO III (2001 - 2005)',
        carbon: { empty: 629.8, full: 976.2 },
        fuelConsumption: { empty: 26.8, full: 41.6 },
      },
      {
        class: 'EURO IV (2006 - 2008)',
        carbon: { empty: 624.7, full: 959.7 },
        fuelConsumption: { empty: 26.5, full: 40.8 },
      },
      {
        class: 'EURO V (2009 - 2014)',
        carbon: { empty: 635.6, full: 970.7 },
        fuelConsumption: { empty: 26.5, full: 40.8 },
      },
      {
        class: 'EURO VI 2015 -->',
        carbon: { empty: 627.6, full: 880.3 },
        fuelConsumption: { empty: 26.2, full: 37.0 },
      },
    ],
  },
  {
    vehicleType: 3,
    fullLoad: 40,
    vehicleMass: 20,
    vehicleTitle:
      'Gross vehicle mass 60 t, pay load capacity 40 t (full trailer combination)',
    environmentalClass: [
      {
        class: '--> 1993',
        carbon: { empty: 763.4, full: 1156.6 },
        fuelConsumption: { empty: 32.5, full: 49.3 },
      },
      {
        class: 'EURO I (1994 - 1995)',
        carbon: { empty: 775.6, full: 1175.2 },
        fuelConsumption: { empty: 33.0, full: 50.1 },
      },
      {
        class: 'EURO II (1996 - 2000)',
        carbon: { empty: 787.5, full: 1193.5 },
        fuelConsumption: { empty: 33.5, full: 50.9 },
      },
      {
        class: 'EURO III (2001 - 2005)',
        carbon: { empty: 807.2, full: 1223.9 },
        fuelConsumption: { empty: 34.4, full: 52.2 },
      },
      {
        class: 'EURO IV (2006 - 2008)',
        carbon: { empty: 790.0, full: 1196.0 },
        fuelConsumption: { empty: 33.5, full: 50.9 },
      },
      {
        class: 'EURO V (2009 - 2014)',
        carbon: { empty: 800.9, full: 1206.9 },
        fuelConsumption: { empty: 33.5, full: 50.9 },
      },
      {
        class: 'EURO VI 2015 -->',
        carbon: { empty: 780.9, full: 1192.6 },
        fuelConsumption: { empty: 32.8, full: 50.4 },
      },
    ],
  },
  {
    vehicleType: 4,
    fullLoad: 51,
    vehicleMass: 25,
    vehicleTitle:
      'Gross vehicle mass 76 t, pay load capacity 51 t, 9 axles (Full trailer combination)',
    environmentalClass: [
      {
        class: 'EURO VI 2015 -->',
        carbon: { empty: 871.5, full: 1431.7 },
        fuelConsumption: { empty: 36.6, full: 60.5 },
      },
    ],
  },
]
